import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ReferFriend as View } from '@views';
import { trackEvent } from '@utils/mixpanel';
import { getReferFriendOptions } from '@store/metadata/duck';
import { LOADING } from '@constants/requestPhase';

const ReferFriend = () => {
  const { getReferFriendPhase, referFriend } = useSelector(store => store.metadataStore);

  const dispatch = useDispatch();

  useEffect(() => {
    const pageTitle = 'Mindspace: Global Access';
    document.title = pageTitle;

    window.gtag('event', 'page_view', {
      page_title: pageTitle,
    });

    trackEvent('Page Viewed', {
      Page: 'Global Access',
    });
  }, []);

  useEffect(() => {
    dispatch(getReferFriendOptions());
  }, []);

  return (
    <View
      link={referFriend?.link}
      text={referFriend.sharingMessage?.text}
      title={referFriend.sharingMessage?.title}
      rewardAmount={referFriend.reward?.amount ? Number(referFriend.reward?.amount) : 0}
      rewardCurrency={referFriend.reward?.currency}
      isLoading={
        getReferFriendPhase === LOADING
      }
    />
  );
};

export default ReferFriend;
